import React, { useState } from "react";
import styled from "styled-components";

import CalendlyEmbed from "../../Elements/Calendly";

// Styled Components
const BookingWrapper = styled.div`
  margin-top: 50px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: bold;
  color: #154890;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 10px 0;
  border-bottom: 2px solid #154890;
  max-width: 80%;
  margin: 0 auto;
`;

const ConfirmationMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #28a745;
`;

const Booking = () => {
  const [message, setMessage] = useState("");

  // Handle form submission (optional if you plan to add a form)
  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage("Booking confirmed. You will be redirected to the scheduling page.");
    // Logic to handle form submission can be added here
  };

  return (
    <BookingWrapper>
      <Title>Schedule a One-on-One Consultancy Meeting</Title>
      
      {/* Optional: Add any additional form fields here */}

      {/* Embedding the Calendly Widget */}
      <CalendlyEmbed />
      
      {message && <ConfirmationMessage>{message}</ConfirmationMessage>}
    </BookingWrapper>
  );
};

export default Booking;
